
export enum SkStatus {
    none,
    created,
    submitted,
    resubmitted,
    rejected,
    approved,
    refused
}